import { Component, Input } from '@angular/core';

import { StudyViewModel } from '../../viewmodel/study.viewmodel';
import { RoleEnum } from '../_study_constants';

@Component({
  selector: 'app-studyaccessinforeadonly',
  templateUrl: './studyAccessInfo_ReadOnly.component.html',
})
export class StudyAccessInfoReadOnlyComponent {
  @Input() studyVM: StudyViewModel = new StudyViewModel();

  private getRoleText(roleId) {
    if (roleId != null) {
      return RoleEnum[roleId];
    }
    return '';
  }
}
